import React, { Fragment, useEffect, useState } from "react";
import CreateIcon from "@mui/icons-material/Create";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import "./BusinessUnitDetailedView.scss";
import PersonSharpIcon from "@mui/icons-material/PersonSharp";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  deleteBusinessUnitService,
  fetchBusinessUnit,
  fetchBusinessUnitPreference,
  fetchCompanyAndBusinessUnits,
} from "../../../services/orgService";
import {
  checkPermissions,
  isMultiSources,
  toastMessage,
} from "../../../helper";
import { STEPS } from "../../../constants/enums";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getCurrencyUomService } from "../../../services/emissionService";
import ConfirmationDialog from "../../common/ConfirmationDialog";
import { removeAdminAssociations } from "../../../services/employeeService";
const BusinessUnitDetailedView = (props: any) => {
  const { t, i18n } = useTranslation();
  const permissions = useSelector((state: any) => state.auth.userPermissions);
  const companyPreferences = useSelector(
    (state: any) => state.org.companyPreferences
  );
  const {
    bunitData,
    onClose,
    controller,
    total_count,
    currentIndex,
    navigateNext,
  } = props;
  const { page, limit } = controller;
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [directEmissionApproval, setDirectEmissionApproval] = useState(false);
  const [step, setStep] = useState(STEPS.DETAILS);
  const [categoryPreferences, setCategoryPreferences] = useState([]);
  const [unitPreferences, setUnitPreferences] = useState<any>({});
  const [currencySymbol, setCurrencySymbol] = useState<any>("");
  let index = limit * page + currentIndex;
  const navigate = useNavigate();
  const [businessUnitDetailedItem, setBusinessUnitDetailedItem] = useState({});
  useEffect(() => {
    fetchBusinessUnit(bunitData.id)
      .then((res) => {
        console.log("detailed item - ", res.data);
        const detailedItem = {
          "Registration ID": res.data.businessUnit.registrationid,
          "Facility type": bunitData?.type_name,
          "Industry type":
            res.data.businessUnit.parentindustrycode &&
            res.data.businessUnit.industryname
              ? res.data.businessUnit.parentindustrycode +
                " / " +
                res.data.businessUnit.industryname
              : "-",
          Email: res.data.businessUnit.email || "-",
          "Contact no":
            res.data.businessUnit.dialcode && res.data.businessUnit.mobile
              ? res.data.businessUnit.dialcode +
                " " +
                res.data.businessUnit.mobile
              : "-",
          Address: res.data.businessUnit.address.addressLine1 || "-",
          "Time Zone": res.data.businessUnit.timezone,
          "Facility Boundary": res.data.businessUnit.facility_boundary,
        };
        setBusinessUnitDetailedItem(detailedItem);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [index]);
  const groupMethodsByTypeSubType = (methods: any[]) => {
    if (methods.length) {
      console.log(
        "groupMethodsByTypeSubType  =  {}",
        groupMethodsByTypeSubType
      );
      console.log("methods  =  {}", methods);
      console.log(
        "ffgfdg = ",
        methods.reduce((accValue, currValue) => {
          accValue[currValue.type + "-" + currValue.sub_type] =
            accValue[currValue.type + "-" + currValue.sub_type] || [];
          accValue[currValue.type + "-" + currValue.sub_type].push(currValue);
          return accValue;
        }, Object.create(null))
      );
    }
    let val = !methods.length
      ? []
      : Object.entries(
          methods.reduce((accValue, currValue) => {
            accValue[currValue.type + "-" + currValue.sub_type] =
              accValue[currValue.type + "-" + currValue.sub_type] || [];
            accValue[currValue.type + "-" + currValue.sub_type].push(currValue);
            return accValue;
          }, Object.create(null))
        );
    console.log("val = {}", val);
    return val;
  };
  useEffect(() => {
    fetchBusinessUnitPreference(bunitData.id, true, {
      fetchAllPreferences: true,
    }).then((res) => {
      console.log("Pref view -> ", res);
      let categoryPreferenceList = res.data.categoryPreferences;
      categoryPreferenceList.sort((a: any, b: any) =>
        a.category_code.localeCompare(b.category_code)
      );
      setCategoryPreferences(categoryPreferenceList);
      if (res.data.preference) {
        setUnitPreferences(res.data.preference);
        setDirectEmissionApproval(res.data.preference.directEmissionApproval);
        const currency = res.data.preference?.currency;
        getCurrencyUomService({ id: currency }).then((res) => {
          setCurrencySymbol(res.data.symbol);
        });
      }
    });
  }, [step, index]);
  const openEdit = () => {
    navigate("/organisation/facilityconfigurations/" + bunitData.id);
  };
  const onNavigateNext = (increment: number) => {
    if (increment > 0 && currentIndex === limit - 1) {
      navigateNext(increment, 1);
    } else if (increment < 0 && currentIndex === 0) {
      navigateNext(increment, -1);
    } else {
      navigateNext(increment, 0);
    }
  };

  const handleDeleteFacility = (confirm: boolean) => {
    if (bunitData.id) {
      if (!confirm) {
        setShowConfirmationDialog(true);
        return;
      }
      setShowConfirmationDialog(false);
      removeAdminAssociations(bunitData.id).then((res) => {
        if (res?.data) {
          if (res.data.count === 0) {
            deleteBusinessUnitService({
              businessUnit: bunitData.id,
            }).then((res) => {
              deleteBusinessUnitService({
                businessUnit: bunitData.id,
              }).then((res) => {
                toastMessage(
                  "Facility has been deleted successfully",
                  "success"
                );
                window.location.reload();

                // let bunitReq: any = {
                //   company: localStorage.getItem("company") &&
                //   JSON.parse(localStorage.getItem("company") || "")?.id,
                //   bunits: localStorage.getItem("bunits") ?? "",
                // };
                // fetchCompanyAndBusinessUnits({}).then((res) => {
                //   if(res?.data) {
                //     let bunits = "";
                //     if (res.data?.businessUnits?.length) {
                //       localStorage.setItem(
                //         "businessUnits",
                //         JSON.stringify(res.data.businessUnits)
                //       );
                //       // if we deleted currect selected business unit
                //       // if(JSON.parse(localStorage.getItem("currentBusinessUnit") || "")?.id === bunitData.id) {
                //       //   localStorage.setItem(
                //       //     "currentBusinessUnit",
                //       //     JSON.stringify({ id: res.data.businessUnits[0].id })
                //       //   );
                //       //   fetchBusinessUnitPreference(res.data.businessUnits[0].id).then(
                //       //     (res: any) => {
                //       //       localStorage.setItem(
                //       //         "categoryPreferences",
                //       //         JSON.stringify(res.data.categoryPreferences)
                //       //       );
                //       //       localStorage.setItem(
                //       //         "preference",
                //       //         JSON.stringify(res.data.preference)
                //       //       );
                //       //     }
                //       //   );
                //       // }
                //       res.data.businessUnits.forEach((eachUnit: any) => {
                //         bunits = bunits + (bunits?.length ? "," : "") + eachUnit.id
                //       });
                //     }
                //     localStorage.setItem("bunits", bunits);
                //   }
                //   window.location.reload();
                // });
              });
            });
          } else {
            toastMessage(
              "This facility cannot be deleted as it is associated with some employees.",
              "info"
            );
          }
        }
      });
    }
  };

  return (
    <Fragment>
      <div className="flex w-70 flex-col px-4 grow pw-detailed-view-main">
        {/* <div className="flex flex-row items-center"> */}
        <div className="flex flex-row items-center gap-6 p-2 px-4">
          <p
            className={`text-sm cursor-pointer pw-border-bottom pt-1 ${
              step === STEPS.DETAILS ? "pw-tab" : ""
            }`}
            onClick={() => {
              setStep(STEPS.DETAILS);
            }}
          >
            {t("Details")}
          </p>
          <p
            className={`text-sm cursor-pointer pw-border-bottom pt-1 pw-e2e-preferences ${
              step === STEPS.PREFERENCES ? "pw-tab" : ""
            }`}
            onClick={() => {
              setStep(STEPS.PREFERENCES);
            }}
          >
            {t("Preferences")}
          </p>

          <div className="pw-bunit-detailed-header w-full flex justify-end gap-3 pr-2">
            {checkPermissions(["UPDATE_FACILITY"], permissions) ? (
              <Button onClick={openEdit} className="pw-editbox-emission">
                <CreateIcon className="pw-bunit-edit-icon text-neutral-600" />
                <div className="pw-edit">{t("Edit")}</div>
              </Button>
            ) : (
              ""
            )}
            {companyPreferences?.account_type === "TRAINER" &&
            checkPermissions(["REMOVE_FACILITY"], permissions) &&
            bunitData.disabled ? (
              <Button
                onClick={() => handleDeleteFacility(false)}
                className="pw-editbox-emission"
              >
                <DeleteIcon className="pw-bunit-delete-icon text-neutral-600" />
                <div className="pw-edit">{t("Delete")}</div>
              </Button>
            ) : (
              ""
            )}
            {/* <ArrowBackIosNewIcon onClick={()=>navigateNext(-1)} className="pw-navigate-next"/>
            <NavigateNextIcon onClick={()=>navigateNext(1)} className="pw-navigate-next"/>
            <CloseIcon onClick={onClose} className="pw-navigate-next"/> */}
            {index > 0 && (
              <div
                onClick={() => onNavigateNext(-1)}
                className="pw-navigate-next pw-padding-5"
              >
                <img src="assets/icons/prev.svg" alt=" " />
              </div>
            )}
            {index < total_count - 1 && (
              <div
                onClick={() => onNavigateNext(1)}
                className="pw-navigate-next pw-padding-5 pw-bunit-next"
              >
                <img src="assets/icons/next.svg" alt=" " />
              </div>
            )}

            <div
              onClick={() => onClose()}
              className="pw-navigate-next items-center"
            >
              <CloseIcon className=" items-center text-neutral-600" />
            </div>
          </div>
        </div>

        {step === STEPS.DETAILS && (
          <div className="flex flex-col pw-detail-main-content gap-5">
            <div className="flex flex-row gap-5">
              <img
                src={
                  bunitData.image_url
                    ? bunitData.image_url
                    : "assets/icons/EmptyBunit.svg"
                }
                alt=" "
                className="pw-bunit-detail-img"
              />
              <div className="flex flex-col justify-center grow">
                <div className="flex flex-row pw-border-bottom justify-between pb-2 pl-0.5 mb-2.5">
                  <div className="flex">
                    <div className="pw-bunit-detail-name text-xl font-semibold text-neutral-900">
                      {" "}
                      {bunitData.name}
                    </div>
                    {bunitData.city && (
                      <div className="pw-bunit-detail-address text-neutral-600">
                        {" "}
                        {bunitData.name}
                      </div>
                    )}
                  </div>

                  <div
                    className={` ${
                      bunitData.disabled ? "text-gray" : "text-primary"
                    }`}
                  >
                    {" "}
                    {!bunitData.disabled ? "Active" : "Inactive"}{" "}
                  </div>
                </div>

                <div className="flex flex-row items-center">
                  <PersonSharpIcon className="pw-bunit-incharge-img mr-2.5 text-neutral-600" />
                  {/* <img className="pw-bunit-incharge-img" src='assets/images/AvatarEmpty.png'/> */}
                  <div className="pw-bunit-incharge-content text-neutral-900 font-normal">
                    {" "}
                    Incharge - {bunitData.incharge_name}
                  </div>
                </div>
              </div>
            </div>
            <div className="pw-bunit-detail-table pl-2">
              {Object.entries(businessUnitDetailedItem).map((obj: any[]) => (
                <div className="flex flex-row pw-bdetail-item gap-3">
                  <div className="w-1/6 text-neutral-600 text-sm">{obj[0]}</div>
                  <div
                    className={`${
                      obj[1] ? obj[0].replace(/[^a-zA-Z0-9]/g, "") : ""
                    } w-5/6 text-neutral-900 text-sm`}
                  >
                    {obj[1]}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {step === STEPS.PREFERENCES && (
          <div className="flex flex-col gap-5">
            <div className="flex flex-col pw-detail-main-content gap-5">
              <div className="text-xs text-neutral-500 font-bold">
                {t("BASIC")}
              </div>
              {/* <div className="flex flex-row items-center w-full">
              <p className="text-sm text-neutral-500 w-1/2">
                {t("Region for Emission Factor Data")} :{" "}
              </p>
              <p className="text-sm w-1/2">{t("India")}</p>
            </div> */}
              <div className="flex flex-row items-start w-full">
                <p className="text-sm text-neutral-500 w-1/2">
                  {t("Scopes/Categories")} :{" "}
                </p>
                <ol className="w-1/2" style={{ listStyleType: "disc" }}>
                  {categoryPreferences
                    .filter((eachCategory: any) => eachCategory.selected)
                    .map((each: any) => (
                      <li
                        className="text-sm pw-e2e-categoryvalues"
                        style={{ marginBottom: "0.25rem" }}
                      >
                        {each.category_code} - {each.category_name}
                      </li>
                    ))}
                </ol>
              </div>
              <div className="flex flex-row items-center w-full">
                <p className="text-sm text-neutral-500 w-1/2">
                  Directly approve all the emissions{" "}
                </p>
                <p className="text-sm w-1/2">
                  {" "}
                  <div>{directEmissionApproval ? "Enabled" : "Disabled"}</div>
                </p>
              </div>
              <div className="flex flex-row items-center w-full">
                <p className="text-sm text-neutral-500 w-1/2">Currency </p>
                <p className="text-sm w-1/2">
                  {" "}
                  <div id="pw-e2e-facilityCurrency">
                    {currencySymbol ? currencySymbol : "-"}
                  </div>
                </p>
              </div>
              <div className="flex flex-row items-center w-full">
                <p className="text-sm text-neutral-500 w-1/2">
                  Carbon price per tCO2e{" "}
                </p>
                <p className="text-sm w-1/2">
                  {" "}
                  <div id="pw-e2e-facilityCarbonprice">
                    {unitPreferences?.carbonPrice
                      ? unitPreferences?.carbonPrice
                      : "-"}
                  </div>
                </p>
              </div>
            </div>
            {categoryPreferences.map((eachPreference: any) => (
              <div className="flex flex-col pw-detail-main-content gap-2">
                <div
                  className={`pw-e2e-dv-maincategory text-xs text-neutral-500 font-bold uppercase mb-2`}
                >
                  {eachPreference.category_code} {eachPreference.category_name}
                </div>
                {eachPreference.selected ? (
                  <div className="flex flex-col items-start w-full mb-2">
                    <table className="w-full border-collapse">
                      <thead className="bg-neutral-50 h-12">
                        <tr>
                          <th className="text-sm text-neutral-600 border border-neutral-200 px-3 py-4 w-2/5 text-left">
                            {t("Emission factor source")}
                          </th>
                          <th className="text-sm text-neutral-600 border border-neutral-200 px-3 py-4 w-3/5 text-left">
                            {t("Log emission against")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {isMultiSources(eachPreference) &&
                        eachPreference?.methods?.length ? (
                          groupMethodsByTypeSubType(
                            eachPreference?.methods
                          )?.map((eachType: any) => (
                            <tr>
                              <td
                                className={`border border-neutral-200 p-3 pw-e2e-categorytype`}
                              >
                                {eachType[1][0].typename ||
                                  eachType[1][0].type_name}
                              </td>
                              <td className="border border-neutral-200 p-3 pw-e2e-categorymethod">
                                <ol className="list-disc ml-4 ">
                                  {eachType[1].map(
                                    (eachMethod: any, index1: number) => (
                                      <>
                                        {eachMethod.selected && (
                                          <li>{eachMethod.name}</li>
                                        )}
                                      </>
                                    )
                                  )}
                                </ol>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td className="border border-neutral-200 p-3 pw-e2e-categorytype">
                              {eachPreference.methods[0].type_name +
                                " - " +
                                eachPreference.methods[0].sub_type_name}
                            </td>
                            <td className="border border-neutral-200 p-3">
                              <ol className="list-disc ml-4 pw-e2e-categorymethod">
                                {eachPreference?.methods?.map(
                                  (eachMethod: any, index1: number) => (
                                    <li>{eachMethod.name}</li>
                                  )
                                )}
                              </ol>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  ""
                )}
                <div className="w-full">
                  <div className="flex flex-row items-center w-full">
                    <p className="text-sm text-neutral-500 mr-4">
                      Emissions Quantified:{" "}
                    </p>
                    <p className="text-sm capitalize w-1/2">
                      {eachPreference.usage?.length
                        ? eachPreference.usage
                        : "No"}
                    </p>
                  </div>
                </div>
                <div className="w-full">
                  <div className="flex flex-row items-start w-full">
                    <p className="text-sm text-neutral-500  mr-4">Comments: </p>
                    <p className="text-sm w-full">
                      {eachPreference.usage_comments?.length
                        ? eachPreference.usage_comments
                        : "-"}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        {/* </div> */}
      </div>
      {showConfirmationDialog && (
        <ConfirmationDialog
          open={showConfirmationDialog}
          onClose={() => setShowConfirmationDialog(false)}
          onConfirm={() => handleDeleteFacility(true)}
          headerText={"Delete selected facility"}
          description={
            "Are you sure you want to delete the selected facility? This action is irreversible. Please click on 'Proceed' to confirm the action."
          }
        />
      )}
    </Fragment>
  );
};

// BusinessUnitDetailedView.propTypes = {}

export default BusinessUnitDetailedView;
